import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { alarmsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

export const putAlarmProfilesAPI = async (
  namespace: string,
  sourceId: string,
  payload: any,
) => {
  const url = alarmsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  try {
    const response = await axios.put(
      `${url}/api/v1/ns/${namespace}/sources/${sourceId}`,
      payload,
      {
        headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update alarm profiles. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while updating alarm profiles.",
    );
  }
};
